import styled from 'styled-components';

const YadoItemAsideView = styled.div`
  --rating: #FAA355;
  position: relative;
  flex: 0 1 auto;
  min-width: 200px;
  border-left: 1px solid var(--gray600);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 150px;
  .rating__container {
    min-width: 280px;
    align-self: flex-end;
    .rating__items {
      margin: 8px;
      display: flex;
      align-self: flex-end;
      flex-direction: row-reverse;
      .scoreRating {
        width: 40px;
        height: 40px;
        border-radius: 4px 4px 4px 16px;
        font-size: 14px;
        font-weight: 600;
        line-height: 40px;
        background-color: var(--rating);
        color: var(--gray0);
        text-align: center;
      }
      .starRating {
        color: var(--rating);
        line-height: 40px;
        margin-right: 6px;
        font-size: 12px;
        i {
          margin: 0;
          padding: 0;
        }
      }
    }
  }
`;

export default YadoItemAsideView;
